import { Component } from 'react';
import ReactDOM from 'react-dom';
// @ts-expect-error Not migrated yet
import { tellParentAboutSentryMessageInIframe } from '../lameErrorHandling';
import Raven from 'raven-js';
export default class AdjacentPortal extends Component {
  componentWillUnmount() {
    if (this.portalElement && this.portalElement.parentNode) {
      this.portalElement.parentNode.removeChild(this.portalElement);
    }
  }
  createPortalElement() {
    const {
      id,
      namespace
    } = this.props;
    const wrapperElement = document.createElement('div');
    wrapperElement.id = id;
    if (namespace) {
      wrapperElement.className = namespace;
    }
    return wrapperElement;
  }
  createAndInsertPortalWrapperIntoDom() {
    const {
      targetElement,
      targetPosition
    } = this.props;
    this.portalElement = this.createPortalElement();
    targetElement.insertAdjacentElement(targetPosition, this.portalElement);
  }
  render() {
    const {
      children,
      targetElement,
      id
    } = this.props;
    if (!targetElement) {
      if (window.hs && window.hs.app) {
        tellParentAboutSentryMessageInIframe('No target element provided to AdjacentPortal in iframe', {
          targetId: id
        });
      } else {
        Raven.captureMessage('No target element provided to AdjacentPortal', {
          extra: {
            targetId: id
          }
        });
      }
      return null;
    }

    // Need to make sure that the portal element exists in the document before children
    // render (for example, tinymce fails to work if the portal element is inserted into
    // the document on `componentDidMount`)
    if (!this.portalElement) {
      this.createAndInsertPortalWrapperIntoDom();
    }
    return /*#__PURE__*/ReactDOM.createPortal(children, this.portalElement);
  }
}